import { createSlice } from '@reduxjs/toolkit'
import { DataList } from '../common'
import {
  fetchSubLayouts,
  createSubLayout,
  modifySubLayout,
  copySubLayout,
  deleteSubLayout,
  fetchLayoutResult,
  modifyLayoutIndex,
  exportLayout
} from './subLayoutAPI'
import type { SubLayout, SubLayoutState } from './types'
import {
  selectIdReducer,
  unselectIdReducer,
  openModalReducer,
  closeModalReducer,
  clearLayoutResultReducer,
  closeAlertReducer,
  dismissErrorReducer,
  buildExtraReducers
} from './subLayoutReducer'

const initialState: SubLayoutState = {
  sort: { column: 'id', order: 'desc' },
  selectedIds: [],
  openedModal: null,
  ...DataList.initialState,
  data: [] as SubLayout[],
  errors: {},
  alert: { show: false, title: null, alertBody: null }
}

export const subLayoutSlice = createSlice({
  name: 'subLayout',
  initialState,
  reducers: {
    selectColumn: DataList.selectColumn,
    selectPage: DataList.selectPage,
    selectId: selectIdReducer,
    unselectId: unselectIdReducer,
    openModal: openModalReducer,
    closeModal: closeModalReducer,
    closeAlert: closeAlertReducer,
    clearLayoutResult: clearLayoutResultReducer,
    dismissError: dismissErrorReducer
  },
  extraReducers: (builder) =>
    buildExtraReducers(builder, {
      fetchSubLayouts,
      createSubLayout,
      modifySubLayout,
      copySubLayout,
      deleteSubLayout,
      fetchLayoutResult,
      modifyLayoutIndex,
      exportLayout
    })
})

export const {
  selectColumn,
  selectPage,
  selectId,
  unselectId,
  openModal,
  closeModal,
  closeAlert,
  clearLayoutResult,
  dismissError
} = subLayoutSlice.actions
